import { AnimatePresence, motion } from "framer-motion";
import { DURATION, EASE_OUT_EXPO, usePrefersReducedMotion } from "@/lib/motion";

type Props = {
  show: boolean;
  children: React.ReactNode;
  className?: string;
};

export function AnimatedAlert({ show, children, className }: Props) {
  const reducedMotion = usePrefersReducedMotion();

  if (reducedMotion) {
    return show ? (
      <div className={className} role="alert">
        {children}
      </div>
    ) : null;
  }

  return (
    <AnimatePresence mode="wait">
      {show ? (
        <motion.div
          key="alert"
          initial={{ opacity: 0, y: -8, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -4, scale: 0.99 }}
          transition={{ duration: DURATION.fast, ease: EASE_OUT_EXPO }}
          className={className}
          role="alert"
        >
          {children}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
